import { React } from 'react';
import styles from '../styles/FormContainer.css';
import { Container, Row, Col } from 'react-bootstrap';

const FormContainer = ({ children }) => {
	return (
		<Container className={styles.container}>
			<Row className="justify-content-md-center">
				<Col xs={12} md={6}>
					{children}
				</Col>
			</Row>
		</Container>
	);
};

export default FormContainer;
